export default __webpack_public_path__ + "static/media/metamask.53ea9825.svg";